(function() {
    'use strict';

    angular
        .module('papp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/admin/account') === 0 )))) {
                $rootScope.$emit('papp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
